import React from "react";
import Layout from "../common/Layout";
import { ENQUIRE } from "../data/constants";

const Enquire = () => (
  <Layout>
    <div className="min-h-[60vh] flex flex-col items-center justify-center py-16">
      <h1 className="text-4xl font-bold mb-4">{ENQUIRE.title}</h1>
      <p className="text-lg text-gray-600">{ENQUIRE.comingSoon}</p>
    </div>
  </Layout>
);

export default Enquire; 